import { render, staticRenderFns } from "./addMenuGroupCatalog.vue?vue&type=template&id=0621a2c3"
import script from "./addMenuGroupCatalog.vue?vue&type=script&lang=js"
export * from "./addMenuGroupCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports